import * as React from "react";
import { connect } from "react-redux";
import Component from "../../AbstractComponent";
import { PromptDialog } from "./PromptDialog";
// import { DatePickerComponent } from "../DatePicker/DatePickerComponent";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { Property } from "../../../Entity/Entities/Property/Property";
import { Unit } from "../../../Entity/Entities/Unit/Unit";
import { Charge } from "../../../Entity/Entities/Charge/Charge";
import { Event } from "../../../Entity/Entities/Event/Event";
import TextField from "../../Partials/Material/TextField";
import Constants from "../../../Action/Constants";
import Time from "../../../Time/Time";
import * as uuidV4 from "uuid/v4";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import Searchbar from "../../Partials/Searchbar/Searchbar";
// import Select from "../../Partials/Material/Select";
// import MenuItem from '@material-ui/core/MenuItem';
import { CoachDialogNewExecutor } from "../../Partials/Dialog/CoachDialogNewExecutor";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { Company } from "../../../Entity/Entities/Company/Company";
import { Person } from "../../../Entity/Entities/Person/Person";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";

class CreateTaskDialog extends Component {
  protected timer;
  protected person: PersonInterface;
  public state = {
    amazonFolderName: uuidV4(),
    entity: null,
    isOpen: false,
    instructions: "",
    details: "",
    reporterId: null,
    reporter: null,
    executorId: this.props?.app?.session?.user?.id,
    executor: this.props?.app?.session?.user,
    executionDate: null,
    isSaving: false,
    error: null,
    disableObjectField: !!this.props.entity,
    eventTypeId: 35, // task // TODO fix hardcoded value
    openPreTaskExecutorCoachDialog: false,
    openPreTaskReporterCoachDialog: false,
    executorType: "person",
    reporterType: "person",
    executorTypeСhoose: true,
    openTaskExecutorCoachDialog: false,
    openTaskReporterCoachDialog: false,
    showExecutorEmailPopup: false,
    showReporterEmailPopup: false,
    contact: null,
    contactId: null,
    contactType: "person",
    contactTypeСhoose: true,
  };

  constructor(public props) {
    super(props);
  }

  public componentWillReceiveProps(nextProps) {
    if (nextProps.entity && nextProps.entity !== this.state.entity) {
      this.setState({
        entity: nextProps.entity
      });
    }

    if (nextProps.isOpen !== this.state.isOpen) {
      this.setState({
        isOpen: nextProps.isOpen
      });
    }

    this.setState({
      isOpen: nextProps.isOpen
    });
  }

  public componentWillUnmount() {
    this.setState({
      entity: null,
      isOpen: false,
    })
  }

  public onCloseDialog() {
    this.setState({
      amazonFolderName: uuidV4(),
      entity: null,
      isOpen: false,
      instructions: "",
      details: "",
      reporterId: null,
      executorId: this.props?.app?.session?.user?.id,
      reporter: null,
      executor: this.props?.app?.session?.user,
      executionDate: null,
      isSaving: false,
      error: null
    });

    if (this.props.closeDialog) {
      this.props.closeDialog();
    }
  }

  public save = () => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENT_CREATE_CLEAR
    });

    const task: any = {
      content: {
        name: this.state.instructions,
        details: this.state.details,
      },
      executorId: this.state.executorId,
      executionDate: this.state.executionDate ? Time.formatOrNull(this.state.executionDate) : null,
      snoozeDate: this.state.executionDate ? Time.formatOrNull(this.state.executionDate) : null,
      reacted: false,
      amazonFolderName: this.state.amazonFolderName,
      reporterId: this.state.reporterId,
      eventTypeId: this.state.eventTypeId
    }

    if (this.state.entity instanceof Property) {
      task.propertyId = this.state.entity?.id;
    }

    if (this.state.entity instanceof Unit) {
      task.unitId = this.state.entity?.id;
    }

    if (this.state.entity instanceof Charge) {
      task.chargeId = this.state.entity?.id;
    }

    if (this.state.entity instanceof Event) {
      task.refersToEventId = this.state.entity?.id;
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_EVENT_CREATE_START,
        payload: {
          ...task
        },
        onSuccess: (event) => {
          this.onCloseDialog();
          return this.redirect(`/app/task/update/${event.id}`)
        },
        onError: (err) => {
          this.setState({
            isSaving: false,
            error: err
          })
        }
      });
    });
  }

  public setTaskName = (event) => {
    const name = event.target.value;

    this.setState({
      instructions: name,
      hasModifiedData: true
    });
  }

  public selectReporter = (reporter: PersonInterface | CompanyInterface): void => {
    if (reporter instanceof Company && (!reporter.generalContact)) {
      this.setState({
        showReporterEmailPopup: true
      })
    }

    this.setState({
      reporterId: reporter instanceof Person
        ? reporter.id
        : reporter instanceof Company && reporter.generalContact?.id
          ? reporter.generalContact?.id
          : null,
      reporter,
    });
  }

  public clearReporter = (): void => {
    this.setState({
      reporterId: null,
      reporter: null,
    });
  }

  public selectPerson = (executor: PersonInterface | CompanyInterface): void => {
    if (executor instanceof Company && !executor.generalContact) {
      this.setState({
        showExecutorEmailPopup: true
      })
    }

    this.setState({
      executorId: executor instanceof Person
        ? executor.id
        : executor instanceof Company && executor.generalContact?.id
          ? executor.generalContact?.id
          : null,
      executor,
    });
  }

  public clearPerson = (): void => {
    this.setState({
      executorId: null,
      executor: null
    });
  }

  public selectDate = (momentDate: any, identifier: string): any => {
    const date = !!momentDate && typeof momentDate.toDate === "function" ? momentDate.toDate() : momentDate;

    this.setState({
      [identifier]: date,
    });
  }

  public selectEntityForTask = (entity): void => {
    this.setState({
      entity: entity,
      hasModifiedData: true
    });
  }

  public clearEntityForTask = (): void => {
    this.setState({
      entity: null,
      hasModifiedData: true
    });
  }

  public updateEventTypeId = (event) => {
    const eventTypeId = event.target.value;

    return this.setState({
      eventTypeId: eventTypeId
    });
  }
  public getCoachContentExecutor = () => {
    return (
      <div className="coach-content-wrapper">
        <div>
          {this.trans("coach/executor-scenario/company-step/first-info1")}
        </div>
        <div>
          <RadioGroup
            className="filters-container"
            value={this.state.executorType}
            onChange={this.chooseExecutorType}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              padding: "10px 0 0 10px",
              width: "500px",
              paddingLeft: "0px"
            }}
          >
            {/* {this.person.role?.getRoleId() === 6 && (
            <FormControlLabel
            control={<Radio color="primary" />}
            value="user"
            label={this.trans("coach/executor-radiobutton/user")}
            style={{ width: "auto", fontSize: "16px", marginRight: "20px" }}
          />
            )} */}

            <FormControlLabel
              control={<Radio color="primary" />}
              value="person"
              label={this.trans("coach/executor-radiobutton/person")}
              style={{ width: "auto", fontSize: "16px", marginRight: "20px" }}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value="company"
              label={this.trans("coach/executor-radiobutton/company")}
              style={{ width: "auto", fontSize: "16px", marginRight: "20px" }}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value="department"
              label={this.trans("coach/executor-radiobutton/department")}
              style={{ width: "auto", fontSize: "16px", marginRight: "20px" }}
            />
          </RadioGroup>
        </div>
        {/* <div>
          {this.trans("coach/executor-scenario/company-step/first-info2")}
        </div> */}
      </div>
    )
  }
  public getCoachContentReporter = () => {
    return (
      <div className="coach-content-wrapper">
        <div>
          {this.trans("coach/executor-scenario/company-step/first-info1")}
        </div>
        <div>
          <RadioGroup
            className="filters-container"
            value={this.state.reporterType}
            onChange={this.chooseReporterType}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              padding: "10px 0 0 10px",
              width: "500px",
              paddingLeft: "0px"
            }}
          >
            {/* {this.person.role?.getRoleId() === 6 && (
            <FormControlLabel
            control={<Radio color="primary" />}
            value="user"
            label={this.trans("coach/executor-radiobutton/user")}
            style={{ width: "auto", fontSize: "16px", marginRight: "20px" }}
          />
            )} */}

            <FormControlLabel
              control={<Radio color="primary" />}
              value="person"
              label={this.trans("coach/executor-radiobutton/person")}
              style={{ width: "auto", fontSize: "16px", marginRight: "20px" }}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value="company"
              label={this.trans("coach/executor-radiobutton/company")}
              style={{ width: "auto", fontSize: "16px", marginRight: "20px" }}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value="department"
              label={this.trans("coach/executor-radiobutton/department")}
              style={{ width: "auto", fontSize: "16px", marginRight: "20px" }}
            />
          </RadioGroup>
        </div>
        {/* <div>
          {this.trans("coach/executor-scenario/company-step/first-info2")}
        </div> */}
      </div>
    )
  }
  public chooseExecutorType = (event) => {
    const choice: string = event.target.value;

    this.setState({
      executorType: choice,
      executorTypeСhoose: true
    });
  }
  public chooseReporterType = (event) => {
    const choice: string = event.target.value;

    this.setState({
      reporterType: choice,
      executorTypeСhoose: true
    });
  }

  public onCloseCoach = () => {
    this.setState({
      openPreTaskExecutorCoachDialog: false,
      executorType: "person",
      // executorTypeСhoose: true,
      openTaskExecutorCoachDialog: false
    })
  }
  public onCloseReporterCoach = () => {
    this.setState({
      openPreTaskReporterCoachDialog: false,
      reporterType: "person",
      // executorTypeСhoose: true,
      openTaskReporterCoachDialog: false
    })
  }

  public setExecutorFromCoach = (executor) => {
    const executorPerson = executor instanceof Company
      ? executor.generalContact
        ? executor.generalContactId
        : executor.persons[0].id
      : executor.id
    this.setState({
      executorId: executorPerson,
      executor: executor
    })
  }

  public setReporterFromCoach = (reporter) => {
    const reporterPerson = reporter instanceof Company
      ? reporter.generalContact
        ? reporter.generalContactId
        : reporter.persons[0].id
      : reporter.id
    this.setState({
      reporterId: reporterPerson,
      reporter: reporter
    })
  }

  public openFirstStep = () => {
    this.setState({
      executorType: this.state.executorTypeСhoose ? this.state.executorType : "person",
      openTaskExecutorCoachDialog: true
    })
  }
  public openFirstStepForReporter = () => {
    this.setState({
      reporterType: this.state.executorTypeСhoose ? this.state.executorType : "person",
      openTaskReporterCoachDialog: true
    })
  }

  public openTaskExecutorCoach = () => {
    if (this.state.executorType !== "user" || this.person?.role && this.person.role?.getRoleId() === 6) {
      this.setState({
        openTaskExecutorCoachDialog: false
      })
    } else {
      this.props.dispatch({
        type: Constants.SNACKBAR_ADD_MESSAGE,
        payload: {
          message: this.trans("coach/executor-scenario/user-step/first-error"),
          type: "error"
        }
      });
      return;
    }
  }

  public saveContactForReporter = () => {
    const person = {
      firstName: this.state.contact?.firstName,
      lastName: this.state.contact?.lastName,
      profession: "",
      email: this.state.contact?.email,
      phone1: this.state.contact?.phone1,
      phone2: "",
      contactRoleId: 3,
      mainBankAccountId: "",
      companyId: this.state.reporter.id,
      address: {
        formattedAddress: ""
      },
      dateOfBirth: null,
      placeOfBirth: {
        formattedAddress: ""
      },
      identityNumber: "",
      identityType: 255,
      amazonFolderName: "",
      note: "",
      pageTemplate: "person",
      genderTypeId: 3,
      languageTypeId: this.props.app.settings.agency?.defaultLanguage?.iso === 'en-US' ? 1 : 2,
      companyIds: [{ id: this.state.reporter.id, role: "" }]
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.PAGE_CONTACT_PERSON_CREATE_START,
        payload: {
          person,
          id: this.state.reporter.id,
        },
        onSuccess: person => {
          this.props.dispatch({
            type: Constants.PAGE_CONTACT_COMPANY_UPDATE_START,
            payload: {
              id: this.state.reporter.id,
              company: {
                ...this.state.reporter.data,
                generalContactId: person.id,
              }
            },
            onSuccess: () => {
              this.setState({
                reporter: person.company,
                reporterId: person.id,
                disableButtonDuringRequest: false,
                errorFields: [],
                isSaving: false,
                showReporterEmailPopup: false,
              })
            }
          })

        },
        onError: error => {
          this.setState({
            disableButtonDuringRequest: false,
            errorFields: error.fields,
            isSaving: false,
          });
        }
      });
    });
  }
  public saveContactForExecutor = () => {
    const person = {
      firstName: this.state.contact?.firstName,
      lastName: this.state.contact?.lastName,
      profession: "",
      email: this.state.contact?.email,
      phone1: this.state.contact?.phone1,
      phone2: "",
      contactRoleId: 3,
      mainBankAccountId: "",
      companyId: this.state.executor.id,
      address: {
        formattedAddress: ""
      },
      dateOfBirth: null,
      placeOfBirth: {
        formattedAddress: ""
      },
      identityNumber: "",
      identityType: 255,
      amazonFolderName: "",
      note: "",
      pageTemplate: "person",
      genderTypeId: 3,
      languageTypeId: this.props.app.settings.agency?.defaultLanguage?.iso === 'en-US' ? 1 : 2,
      companyIds: [{ id: this.state.executor.id, role: "" }]
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.PAGE_CONTACT_PERSON_CREATE_START,
        payload: {
          person,
          id: this.state.executor.id,
        },
        onSuccess: person => {
          this.props.dispatch({
            type: Constants.PAGE_CONTACT_COMPANY_UPDATE_START,
            payload: {
              id: this.state.executor.id,
              company: {
                ...this.state.executor.data,
                generalContactId: person.id,
              }
            },
            onSuccess: () => {
              this.setState({
                executor: person.company,
                executorId: person.id,
                disableButtonDuringRequest: false,
                errorFields: [],
                isSaving: false,
                showExecutorEmailPopup: false,
              })
            }
          })

        },
        onError: error => {
          this.setState({
            disableButtonDuringRequest: false,
            errorFields: error.fields,
            isSaving: false,
          });
        }
      });
    });
  }

  public openTaskReporterCoach = () => {
    {
      this.setState({
        // openPreTaskReporterCoachDialog: false,
        openTaskReporterCoachDialog: false
      })
    }
  }
  public chooseContactType = (event) => {
    const choice: string = event.target.value;

    this.setState({
      contactType: choice,
      contactTypeСhoose: true
    });
  }

  public getContactCoachContent = (role: string) => {
    const companyName = role === 'reporter' ? this.state.reporter?.displayName : this.state.executor?.displayName

    return (
      <div>
        <div>
          {this.trans("coach/create-contact-for-company", { companyName })}
        </div>
        <div>
          <RadioGroup
            className="filters-container"
            value={this.state.contactType}
            onChange={this.chooseContactType}
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              padding: "10px 0 0 10px",
              width: "500px",
              paddingLeft: "0px"
            }}
          >
            <FormControlLabel
              control={<Radio color="primary" />}
              value="person"
              label={this.trans("coach/executor-radiobutton/person")}
              style={{ width: "auto", fontSize: "16px", marginRight: "20px" }}
            />
            <FormControlLabel
              control={<Radio color="primary" />}
              value="department"
              label={this.trans("coach/executor-radiobutton/department")}
              style={{ width: "auto", fontSize: "16px", marginRight: "20px" }}
            />
          </RadioGroup>
        </div>

        {this.state.contactType === "person" && (
          <div className="coach-content-wrapper">
            <div className="info-next">{this.trans("coach/executor-scenario/person-step/second-info1")}</div>
            <div>
              <TextField
                autoComplete="off"
                // id="firstName"
                // name="firstName"
                className="form-element full-size"
                type="text"
                label={this.trans("coach/propertyowner-scenario/person-step/second-field/firstname-label")}
                value={this.state.contact?.firstName}
                onChange={(e) => this.setState({ contact: { ...this.state.contact, firstName: e.target.value } })}
                autoFocus={true}
                variant="standard"
                error={this.state.contact?.firstNameError || this.getErrorFor("contacts.firstName") || this.getErrorFor("firstName")}
              />
              {!!this.getErrorFor("contacts.firstName") || !!this.getErrorFor("firstName") ? <div className="component-error-text">{this.getErrorFor("contacts.firstName") ? this.getErrorFor("contacts.firstName") : this.getErrorFor("firstName")}</div> : this.state.contact?.firstNameError && <div className="component-error-text">{this.trans("this-field-is-required")}</div>}

              <TextField
                autoComplete="off"
                // id="lastName"
                // name="lastName"
                className="form-element full-size"
                type="text"
                label={this.trans("coach/executor-scenario/person-step/second-field/lastname-label") + this.trans("field/optional")}
                value={this.state.contact?.lastName}
                onChange={(e) => this.setState({ contact: { ...this.state.contact, lastName: e.target.value } })}
                variant="standard"
                error={!!this.getErrorFor("lastName")}
              />
              {!!this.getErrorFor("lastName") && <div className="component-error-text">{this.getErrorFor("lastName")}</div>}
              {

              }
              <TextField
                autoComplete="off"
                className="form-element full-size"
                label={`${this.trans("coach/executor-scenario/person-step/second-field/email-label")} ${this.state.contact?.type === "person" ? this.trans("field/optional") : ""}`}
                value={this.state.contact?.email}
                onChange={(e) => this.setState({ contact: { ...this.state.contact, email: e.target.value } })}
                variant="standard"
                error={!!this.getErrorFor("email") || !!this.getErrorFor("contacts.email")}
              />
              {!!this.getErrorFor("email") && <div className="component-error-text">{this.getErrorFor("email")}</div>}

              <div>
                <TextField
                  autoComplete="off"
                  // id="phone1"
                  //name="phone1"
                  className="form-element full-size"
                  type="text"
                  label={this.trans("phone") + this.trans("field/optional")}
                  value={this.state.contact?.phone1}
                  onChange={(e) => this.setState({ contact: { ...this.state.contact, phone: e.target.value } })}
                  variant="standard"
                  error={!!this.getErrorFor("phone1")}
                />
                {!!this.getErrorFor("phone1") && <div className="component-error-text">{this.getErrorFor("phone1")}</div>}
              </div>
            </div>
          </div>
        )}

        {this.state.contactType === "department" && (
          <div className="coach-content-wrapper">
            <div className="info-text">
              {this.trans("coach/executor-scenario/department-step/second-info1")}
            </div>

            <TextField
              autoComplete="off"
              // id="firstName"
              // name="firstName"
              className="form-element full-size"
              type="text"
              label={this.trans("coach/poaowner-scenario/company-step/second-field/department-label")}
              value={this.state.contact?.firstName}
              onChange={(e) => this.setState({ contact: { ...this.state.contact, firstName: e.target.value } })}
              variant="standard"
              error={this.state.contact?.firstNameError || this.getErrorFor("contacts.firstName")}
            />
            {!!this.getErrorFor("contacts.firstName") ? <div className="component-error-text">{this.getErrorFor("contacts.firstName")}</div> : this.state.contact?.firstNameError && <div className="component-error-text">{this.trans("this-field-is-required")}</div>}

            <TextField
              autoComplete="off"
              className="form-element full-size"
              label={this.trans("label-email") + this.trans("field/optional")}
              value={this.state.contact?.email}
              onChange={(e) => this.setState({ contact: { ...this.state.contact, email: e.target.value } })}
              variant="standard"
              error={!!this.getErrorFor("email") || !!this.getErrorFor("contacts.email")}
            />
            {!!this.getErrorFor("email") && <div className="component-error-text">{this.getErrorFor("email")}</div>}
            <div>
              <TextField
                autoComplete="off"
                // id="phone1"
                //name="phone1"
                className="form-element full-size"
                type="text"
                label={this.trans("phone") + this.trans("field/optional")}
                value={this.state.contact?.phone1}
                onChange={(e) => this.setState({ contact: { ...this.state.contact, phone1: e.target.value } })}
                variant="standard"
                error={!!this.getErrorFor("phone1")}
              />
              {!!this.getErrorFor("phone1") && <div className="component-error-text">{this.getErrorFor("phone1")}</div>}
            </div>
          </div>
        )}
      </div>
    )
  }
  public getReporterDisplayName = () => {
    let reporterDisplayName

    switch (true) {
      case this.state.reporter instanceof Company:
        reporterDisplayName = this.state.reporter?.generalContact ? `${this.state.reporter?.generalContact?.displayName?.trim()} (${this.state.reporter.name})` : `${this.state.reporter.name}`
        break;
      case !!this.state.reporter?.company:
        reporterDisplayName = this.state.reporter?.displayName ? `${this.state.reporter?.displayName?.trim()} (${this.state.reporter.company.name})` : `${this.state.reporter.company.name}`
        break;
      case this.state.reporter instanceof Person:
        reporterDisplayName = `${this.state.reporter?.displayName}`
        break;
      default:
        reporterDisplayName = ""
        break;
    }

    return reporterDisplayName
  }
  public getExecutorDisplayName = () => {
    let executorDisplayName
    switch (true) {
      case this.state.executor instanceof Company:
        executorDisplayName = this.state.executor.generalContact ? `${this.state.executor.generalContact?.displayName?.trim()} (${this.state.executor.name})` : `${this.state.executor.name}`
        break;
      case !!this.state.executor?.company:
        executorDisplayName = this.state.executor?.displayName ? `${this.state.executor?.displayName?.trim()} (${this.state.executor.company.name})` : `${this.state.executor.company.name}`
        break;
      case this.state.executor instanceof Person:
        executorDisplayName = `${this.state.executor?.displayName}`
        break;
      default:
        executorDisplayName = ""
        break;
    }

    return executorDisplayName
  }
  public renderContent = () => {
    return (
      <div style={{ width: "97%" }}>
        {/* <Select
          className="form-element full-size scroll-to-eventTypeId"
          error={this.getErrorFor("eventTypeId")}
          value={this.state.eventTypeId}
          onChange={this.updateEventTypeId}
          htmlFor="eventTypeId"
          label={this.trans("label-type")}
          name="eventTypeId" 
          id="eventTypeId"
        > */}
        {/* TODO fix hardcoded value */}
        {/* <MenuItem
            key={`eventTypeId-${35}`}
            value={35}
          >
            {this.trans("task")}
          </MenuItem>
          <MenuItem
            key={`eventTypeId-${38}`}
            value={38}
          >
            {this.trans("incident")}
          </MenuItem>
        </Select> */}

        <div className="search-bar-container" style={{ margin: "-14px 0 0 0" }}>
          <Searchbar
            {...this.props}
            id="selectedEntityForNewTask"
            className="scroll-to-objectId"
            floatingLabelText={this.trans("object")}
            allResults={true}
            objectField={true}
            onChange={this.selectEntityForTask}
            onClear={this.clearEntityForTask}
            searchText={this.state.entity ? `${this.state.entity.nameOfEntity}, ${this.state.entity.displayName}` : undefined}
            selectedEntity={this.state.entity}
            error={this.state.error && this.getErrorFor("objectId")}
            searchParameter={"objectForTaskSearch"}
            disabled={this.state.disableObjectField}
            styleInModal={"pick-object-modal"}
          />
        </div>

        <div style={{ margin: "-8px 0 0 0" }}>
          <TextField
            autoComplete="off"
            className="form-element full-size scroll-to-name"
            type="text"
            label={this.trans("label-description")}
            value={this.state.instructions}
            onChange={this.setTaskName}
            autoFocus={true}
            variant="standard"
            multiline
            rowsMax="25"
            rows="3"
            error={this.state.error && !!this.getErrorFor("name")}
            helperText={this.state.error && this.getErrorFor("name")}
          />

        </div>
        <div className="search-bar-container" style={{ margin: "-28px 0 -28px 0" }}>
          <Searchbar
            {...this.props}
            name="personId"
            className="scroll-to-mainTenantContactId"
            id="selectedTenantForContract"
            ref="PersonLookup"
            floatingLabelText={this.trans("reported-by") + this.trans("field/optional")}
            allResults={true}
            objectField={true}
            onChange={this.selectReporter}
            onClear={this.clearReporter}
            selectedEntity={this.state.reporter}
            searchParameter={"contactsSearch"}
            error={this.getErrorFor("mainTenantContactId") || this.getErrorFor("contactForContracts[0].contactId")}
            searchText={this.getReporterDisplayName()}
            styleInModal={"pick-object-modal"}
            openCoachCreateNewEntity={() => this.setState({ openTaskReporterCoachDialog: true })}
            createButton={"button-add-person"}
          />
        </div>
      
        <div className="search-bar-container" style={{ margin: "-14px 0" }}>
          <Searchbar
            {...this.props}
            name="personId"
            className="scroll-to-mainTenantContactId"
            id="selectedTenantForContract"
            ref="PersonLookup"
            floatingLabelText={this.trans("to-do-by") + this.trans("field/optional")}
            allResults={true}
            objectField={true}
            onChange={this.selectPerson}
            onClear={this.clearPerson}
            selectedEntity={this.state.executor}
            searchParameter={"contactsSearch"}
            error={this.getErrorFor("mainTenantContactId") || this.getErrorFor("contactForContracts[0].contactId")}
            searchText={this.getExecutorDisplayName()}
            styleInModal={"pick-object-modal"}
            openCoachCreateNewEntity={() => this.setState({ openTaskExecutorCoachDialog: true })}
            createButton={"button-add-person"}
          />
        </div>

        {/* <DatePickerComponent
          {...this.props}
          className="scroll-to-executionDate"
          label={this.trans("show-me-from-task-dialog") + this.trans("field/optional")}
          initialDate={this.state.executionDate}
          onChange={date => this.selectDate(date, "executionDate")}
          minDate={new Date()}
          minDatePlusDays={0}
          clearButton={true}
          error={this.getErrorFor("executionDate")}
        /> */}
      </div>
    );
  }

  public render() {
    return (
      <div>
        <PromptDialog
          {...this.props}
          openLeavePrompt={this.state.isOpen}
          title={this.trans("new-task")}
          subtitle={this.state.entity?.displayName ?
            this.state.entity?.displayName : ""}
          content={
            this.renderContent()
          }
          positiveButtonLabel={this.trans("dialog/createtask-button/finish")}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          onSave={() => this.save()}
          onDiscard={() => this.onCloseDialog()}
          innerDialogClasses="dialog-create-task"
        />

        <CoachDialogNewExecutor
          {...this.props}
          openTaskExecutorCoachDialog={this.state.openTaskExecutorCoachDialog}
          type={this.state.executorType}
          setExecutor={this.setExecutorFromCoach}
          openFirstStep={this.openFirstStep}
          onCloseCoach={this.onCloseCoach}
          firstStep={this.getCoachContentExecutor}
        />

        <CoachDialogNewExecutor
          {...this.props}
          openTaskExecutorCoachDialog={this.state.openTaskReporterCoachDialog}
          type={this.state.reporterType}
          setExecutor={this.setReporterFromCoach}
          openFirstStep={this.openFirstStepForReporter}
          onCloseCoach={this.onCloseReporterCoach}
          firstStep={this.getCoachContentReporter}
        />

        <PromptDialog
          {...this.props}
          // title={this.trans("coach/create-contact-for-company", { companyName: this.state.reporter?.displayName})}
          content={this.getContactCoachContent('reporter')}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          positiveButtonLabel={this.trans("button-save")}
          openLeavePrompt={this.state.showReporterEmailPopup}
          prioritizeClosing={true}
          // innerDialogClasses="dialog-assistant coach-executor"
          innerDialogClasses="dialog-create-task"
          onDiscard={() => {
            this.setState({
              showReporterEmailPopup: false,
              reporter: null
            });
          }}
          onSave={this.saveContactForReporter}
        />
        <PromptDialog
          {...this.props}
          // title={this.trans("coach/create-contact-for-company", { companyName: this.state.reporter?.displayName})}
          content={this.getContactCoachContent('executor')}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          positiveButtonLabel={this.trans("button-save")}
          openLeavePrompt={this.state.showExecutorEmailPopup}
          prioritizeClosing={true}
          // innerDialogClasses="dialog-assistant coach-executor"
          innerDialogClasses="dialog-create-task"
          onDiscard={() => {
            this.setState({
              showExecutorEmailPopup: false,
              executor: null,
            });
          }}
          onSave={this.saveContactForExecutor}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    component: state.taskCreateDialog,
    globalTypes: state.globalTypes,
  };
};

export default connect(mapStateToProps)(
  CreateTaskDialog
);